<template>
  <div class="container-fluid px-3">
    <div class="row justify-content-end no-gutters mb-3">
      <div class="col-6 px-1">
        <input type="date" class="form-control" v-model="date" @change="getDados()" :disabled="loadResumo">
      </div>
      <div class="col-6 px-1" v-if="empresas.length > 1">
        <select class="form-control" v-model="id_empresa" @change="getDados()" :disabled="loadResumo">
          <option :value="e.id_empresa" v-for="e in empresas">{{e.nome_fantasia}}</option>
        </select>
      </div>
    </div>
    <div class="py-5 my-5 text-center" v-if="loadResumo">
      <loading/>
      <div class="small mt-4">Gerando o resumo do dia</div>
    </div>
    <div id="resumoDiario" v-if="!loadResumo && resumo.data_pedido">
      <div class="text-center">
        <div><b>Resumo dos Pedidos</b></div>
        <div>{{ resumo.data_pedido }}</div>
      </div>
      <hr>
      <div class="mb-2" v-if="resumo.pagamentos">
        <b class="mb-1"># Pagamentos</b>
        <div class="small" v-for="p in resumo.pagamentos">
          <span class="right">{{ p.total | valor }}</span>
          - {{ p.nome_pagamento }} ({{p.qtd}}):
        </div>
      </div>
      <div class="mb-2" v-if="resumo.operacao">
        <b class="mb-1"># Operações</b>
        <div class="small" v-for="op in resumo.operacao">
          <span class="right">{{ op.total | valor }}</span>
          - {{op.tipo_pedido | tipo}} ({{op.qtd}}):
        </div>
      </div>
      <div class="mb-2" v-if="resumo.origin">
        <b class="mb-1"># Origem dos Pedidos</b>
        <div class="small" v-for="or in resumo.origin">
          <span class="right">{{ or.total | valor }}</span>
          - {{ or.origin | origin }} ({{or.qtd}}):
        </div>
      </div>
      <div class="mb-2" v-if="resumo.entregadores && resumo.entregadores.length">
        <div>
          <b># Entregadores</b>
          <b class="right">Taxas</b>
        </div>
        <div class="small" v-for="e in resumo.entregadores">
          <span class="right">{{ e.total | valor }}</span>
          - {{ e.nome_entregador || 'Não vinculado' }} ({{ e.qtd }}):
        </div>
        <hr>
      </div>
      <div>
        <b class="mb-1"># Totais</b>
        <div class="small">
          <div v-if="resumo.cancelados">
            <span class="right">{{ resumo.cancelados.total | valor }}</span>
            - Cancelados ({{resumo.cancelados.qtd}}):
          </div>
          <div>
            <span class="right font-weight-bold">{{ resumo.finalizados.total | valor }}</span>
            <div> - Realizados ({{ resumo.finalizados.qtd }}):</div>
          </div>
        </div>
      </div>
      <component is="style">
        .right { float: right }
        .text-center { text-align: center }
        .mb-2 { margin-bottom: 7px }
      </component>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/gestor/loading";
export default {
  name: "ResumoPedidos",
  components: {Loading},
  props: ['empresas', 'pesquisa'],
  data() {
    return {
      loadResumo: false,
      id_empresa: '',
      resumo: {},
      token: localStorage.getItem('key'),
      date: new Date().toDateInputValue()
    }
  },

  methods: {
    getDados() {
      this.loadResumo = true;
      let params = { data: this.date, token: this.token, id_empresa: this.id_empresa };
      this.$http.get('delivery/relatorio-gestor', { params })
        .then(response => {
          this.loadResumo = false;
          this.resumo = response.data || {};

        }, res => {
          console.log(res);
          this.loadResumo = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    }
  },

  mounted() {
    if (this.pesquisa && this.pesquisa.filtro === '2' && this.pesquisa.data) {
      this.date = this.pesquisa.data;
    }

    this.id_empresa = this.empresas.length > 1 ? this.empresas[0].id_empresa : null;
    this.getDados();
  },

  filters: {
    valor(value) {
      const formatter = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL', minimumFractionDigits: 2});
      return value ? formatter.format(parseFloat(value)) : 'R$ 0,00';
    },

    tipo(value) {
      switch (value) {
        case '1':
          return 'Entrega';
        case '2':
          return 'Retirada';
        case '3':
          return 'Consumir no Local';
      }
    },

    origin(value) {
      switch (value) {
        case '1':
          return 'App/Site';
        case '2':
          return 'Geral';
        case '3':
          return 'Pedido Manual';
        case '4':
          return 'Qr Code';
        case '5':
          return 'WhatsApp';
        case '6':
          return 'iFood';
        case '7':
          return 'UaiRango';
        case '9':
          return 'Keeta';
        case '10':
          return 'AiqFome';
        case '11':
          return '99Food';
      }
    },
  }
}
</script>

<style scoped>
</style>
